import { CouponService } from "../../../service/coupon-service-api";
import Types from "./types";

const fetchBankOfferCouponsSuccess = (offers) => ({
    type: Types.FETCH_BANK_OFFER_COUPONS_SUCCESS,
    offers
});

const fetchBankOfferCouponsFailure = (error) => ({
    type: Types.FETCH_BANK_OFFER_COUPONS_FAILURE,
    error
});

const fetchBankOfferCoupons = ({ clientId, secureToken }) => dispatch => {
    return new Promise((resolve, reject) => {
        CouponService.fetchBankOfferCoupons(clientId, secureToken)
            .then(response => {
                dispatch(fetchBankOfferCouponsSuccess(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchBankOfferCouponsFailure(error));
                reject(error);
            });
    });
};

const fetchBankOfferCouponsById = (offerId) => () => {
    return new Promise((resolve, reject) => {
        CouponService.fetchBankOfferCouponsById(offerId)
            .then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const setShowSelectBankOffer = (showSelectedBankOfferData) => ({
    type: Types.SET_SHOW_SELECTED_BANK_OFFER,
    showSelectedBankOfferData
});

const updateSSRStatus = (isSSR) => ({
    type: Types.UPDATE_SSR_STATUS,
    isSSR
});

const fetchUserOffer = (clientId, secureToken, params) => dispatch => {
    return new Promise((resolve, reject) => {
        CouponService.fetchUserOffer(clientId, secureToken, params)
            .then(response => {
                dispatch(fetchBankOfferCouponsSuccess(response.data));
                resolve(response.data);
            }).catch(error => {
                dispatch(fetchBankOfferCouponsFailure(error));
                reject(error);
            });
    });
};

export {
    fetchBankOfferCoupons,
    updateSSRStatus,
    setShowSelectBankOffer,
    fetchBankOfferCouponsById,
    fetchUserOffer
};
